import { render } from "./notification.html?vue&type=template&id=55a841ac&scoped=true&external"
import script from "./notification.ts?vue&type=script&lang=js&external"
export * from "./notification.ts?vue&type=script&lang=js&external"

import "./notification.scss?vue&type=style&index=0&id=55a841ac&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55a841ac"],['__file',"src/view/dashboard/notification/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "55a841ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('55a841ac', __exports__)) {
    api.reload('55a841ac', __exports__)
  }
  
  module.hot.accept("./notification.html?vue&type=template&id=55a841ac&scoped=true&external", () => {
    api.rerender('55a841ac', render)
  })

}


export default __exports__